import React from "react";
export const SubHeadWithButton = React.memo(({heading, buttons=[], isReport}) => {
    buttons = buttons || [];
    if (isReport) {
      return (<h3>{heading}</h3>);
    }
    return (<h3 className="subhead">
            {heading}
            {!isReport && <div className="subhead-button">
              {buttons.map((button, index) => (
                  <button type="button" key={index} onClick={button.onClick} className={button.className} style={button.style}>{button.buttonText}</button>
              ))}
            </div>}
          </h3>);
});